/*
  carousel-energy-label.js
  ────────────────────────
  Re-triggers the Staylime energy-label app on carousel product cards.

  Why: the app (<embed-block-energy-label> / script-embed.js) scans the DOM ONCE
  at init and injects the EPREL badge into elements matching its configured
  product-card selector (collection-grid-item). Swiper builds the "Udvalgte
  produkter" slides AND the product-recommendations cells AFTER that scan, and
  the app has no observer for late-built cards — so carousel cards never get a
  badge. We watch for those cards, re-init the app until every energy card is
  hydrated, then let the observer expire.

  Server-rendered prerequisites (in the carousel Liquid):
    - each slide carries the `collection-grid-item` class (the app's closest()
      injection target);
    - hidden `.eprel-product-list[data-product-url][data-product-eprel]` nodes
      map each energy product's URL to its EPREL number for the app.

  Cleanups over the app vendor's inline snippet: lives in an asset (no inline
  <script>), one global guard, the per-card work is scoped to `.pc__carousel`,
  pending() only counts cards that actually expect a badge (so it stops churning
  once they are all hydrated), and the observer hard-stops after a bounded window
  instead of watching the document forever.
*/
(function () {
  if (window.__ggmEnergyCarousel) return;
  window.__ggmEnergyCarousel = true;

  var CARD = '.pc__carousel .collection-grid-item';
  var MAX_WATCH_MS = 20000; // hard stop: bounds the observer's lifetime
  var COOLDOWN_MS = 1500; // let the app finish a pass before re-checking

  function reinit() {
    var el = document.querySelector('embed-block-energy-label');
    if (el && typeof el.init === 'function') {
      el.init();
      return;
    }
    // No live element: clone the app's config off its embed script and mount one.
    var script = Array.prototype.slice
      .call(document.querySelectorAll('script[src*="script-embed.js"]'))
      .filter(function (s) { return s.hasAttribute('data-cssselectorproduct'); })[0];
    if (!script) return;
    var node = document.createElement('embed-block-energy-label');
    Array.prototype.slice
      .call(script.attributes)
      .filter(function (a) { return a.name.indexOf('data-') === 0; })
      .forEach(function (a) { node.setAttribute(a.name, a.value); });
    document.body.appendChild(node);
  }

  // True while any carousel card that *expects* a badge is still missing it.
  // A card expects one when its product URL matches a surfaced .eprel-product-list
  // node; non-energy cards are ignored so we don't re-init forever.
  function pending() {
    var energy = {};
    document.querySelectorAll('.eprel-product-list[data-product-url]').forEach(function (n) {
      energy[n.getAttribute('data-product-url')] = true;
    });
    var cards = document.querySelectorAll(CARD);
    for (var i = 0; i < cards.length; i++) {
      var link = cards[i].querySelector('a[href*="/products/"]');
      if (!link) continue;
      var url = link.getAttribute('href').split('?')[0];
      if (energy[url] && !cards[i].querySelector('.card-information-eprel')) return true;
    }
    return false;
  }

  var cooldown = false;
  var observer = new MutationObserver(function () {
    if (cooldown || !pending()) return;
    cooldown = true;
    reinit();
    setTimeout(function () { cooldown = false; }, COOLDOWN_MS);
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, MAX_WATCH_MS);
    if (pending()) reinit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
